import { forwardRef } from 'react'
import { clsx } from 'clsx'
import styles from './Button.module.css'

/**
 * @typedef {Object} ButtonProps
 * @property {React.ReactNode} children
 * @property {'primary'|'secondary'|'destructive'|'outline'|'ghost'} variant
 * @property {'sm'|'md'|'lg'} size
 * @property {boolean} disabled
 * @property {string} className
 * @property {Function} onClick
 * @property {string} type
 */

/**
 * @param {ButtonProps} props
 */
const Button = forwardRef(({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className, 
  ...props 
}, ref) => {
  return (
    <button
      ref={ref}
      className={clsx(
        styles.button,
        styles[variant],
        styles[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
})

Button.displayName = 'Button'

export default Button
